import { render, staticRenderFns } from "./AssignMediator.vue?vue&type=template&id=285782c8"
import script from "./AssignMediator.vue?vue&type=script&lang=js"
export * from "./AssignMediator.vue?vue&type=script&lang=js"
import style0 from "./AssignMediator.vue?vue&type=style&index=0&id=285782c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports